// Promotion Getters

export const getPromotionList = state => {
  return state.promotionList
}

export const getPromotionInfo = state => {
  return state.promotionInfo
}

export const getCustomerRules = state => {
  return state.customerRules
}

export const getProductRules = state => {
  return state.productRules
}

export const getAmountRuleTypes = state => {
  return state.amountRuleTypes
}

export const getRewardTypes = state => {
  return state.rewardTypes
}
